import { Typography } from '@mui/material';

export function SelectPlaceholder({ title = 'Select' }: { title?: string }) {
  return (
    <Typography
      variant='body1'
      color='var(--mui-palette-text-disabled)'
      className='truncate'
      alignContent='center'
      component={'span'}
    >
      {title}
    </Typography>
  );
}
